export default "__VITE_ASSET__C25PLw6r__"